import React, { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";

import { authService } from "../services/authService";
import { savePostLoginRedirect } from "../services/postLoginRedirect";
import { claimLevelTestGiftAPI } from "../features/leveltest/levelTestAPI";
import { LEVEL_TEST_GUIDE_PATH } from "../features/leveltest/components/LevelTestCodeVault";
import "./LevelTestGiftPage.css";

// 레벨테스트 이용권 링크(2026-10-08 대표: 단톡방에 뿌린다). 규칙은 api/echo/leveltest_gift.py.
//
// 로그인 전이면 무엇을 받는지 보여 주고 '지인에듀 아이디로 받기' 를 누르게 한다. 로그인을 거쳐 돌아오면
// (postLoginRedirect) 그 자리에서 코드가 들어가고, 바로 따라하기 안내로 이끈다. 다시 눌러도 한 번뿐이다.

const MY_LEVEL_TEST_PATH = "/academy/leveltest";

const formatDate = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return `${date.getMonth() + 1}월 ${date.getDate()}일`;
};

const LevelTestGiftPage = () => {
  const { key } = useParams();
  const [searchParams] = useSearchParams();
  const cafeToken = searchParams.get("cafe") || "";
  const isLoggedIn = authService.isAuthenticated();
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!isLoggedIn) return;
    claimLevelTestGiftAPI(key, cafeToken)
      .then(setResult)
      .catch((requestError) =>
        setError(requestError?.response?.data?.error || "이용권을 받지 못했어요. 잠시 뒤 다시 눌러 주세요.")
      );
  }, [isLoggedIn, key, cafeToken]);

  const startLogin = () => {
    savePostLoginRedirect(window.location.pathname + window.location.search);
    window.location.href = "/login";
  };

  let body;
  if (!isLoggedIn) {
    body = (
      <>
        <p className="gift-page__lead">지인에듀 아이디로 로그인하면 바로 받아요.</p>
        <button type="button" className="gift-page__main" onClick={startLogin}>
          지인에듀 아이디로 받기
        </button>
        <a className="gift-page__sub" href={LEVEL_TEST_GUIDE_PATH}>
          어떻게 쓰는지 먼저 보기
        </a>
      </>
    );
  } else if (error) {
    body = (
      <>
        <p className="gift-page__error">{error}</p>
        <a className="gift-page__main" href={MY_LEVEL_TEST_PATH}>
          레벨테스트 관리로 가기
        </a>
      </>
    );
  } else if (!result) {
    body = <p className="gift-page__lead">이용권을 넣고 있어요…</p>;
  } else {
    body = (
      <>
        <p className="gift-page__done">
          {result.is_new ? "✅ 이용권이 들어갔어요!" : "이미 받으셨어요. 코드는 그대로 있어요."}
        </p>
        <p className="gift-page__lead">
          <b>레벨테스트 관리</b>의 응시코드함에 들어 있어요
          {result.expires ? ` (${formatDate(result.expires)}까지)` : ""}.
          <br />
          학생에게 코드를 보내고 점수·리포트를 보는 방법을 1분이면 따라 해 볼 수 있어요.
        </p>
        <a className="gift-page__main" href={LEVEL_TEST_GUIDE_PATH}>
          ▶ 사용법 따라 해 보기
        </a>
        <a className="gift-page__sub" href={MY_LEVEL_TEST_PATH}>
          내 코드 바로 보기
        </a>
      </>
    );
  }

  return (
    <div className="gift-page">
      <div className="gift-page__card">
        <span className="gift-page__chip">레벨테스트 이용권</span>
        <h1 className="gift-page__title">
          파닉스 레벨테스트 {result?.phonics_count ?? 5}회
          <br />+ 전체 12레벨 레벨테스트 {result?.level_count ?? 5}회
        </h1>
        {body}
      </div>
    </div>
  );
};

export default LevelTestGiftPage;
